module.exports = __webpack_public_path__ + "static/smart-9bb7f34fd072733b0a95f2f2fc9bf26b.gif";